import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

export default function Logo() {
  const imageRef = useRef(null);
  const logoRef = useRef(null);
  const [animationFinished, setAnimationFinished] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' });

  useEffect(() => {
    const image = imageRef.current;
    const logoHash = logoRef.current;
    const loadingElement = document.getElementById('loading');

    const disableScroll = () => {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    };

    const enableScroll = () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };

    disableScroll();

    const startAnimation = () => {
      if (isDesktopOrLaptop) {
        image.classList.add('animate-dropDesk');
      } else {
        image.classList.add('animate-dropMobile');
      }

      setTimeout(() => {
        loadingElement.classList.add('animate-fadeOut');
        logoHash.classList.remove('hidden');

        setTimeout(() => {
          loadingElement.classList.add('hidden');
          setAnimationFinished(true);
        }, 400);
      }, 1200);
    };

    startAnimation();
    document.body.style.overflow = ""; 
    setTimeout(() => {
      enableScroll();
    }, 1000);
    return () => enableScroll();
  }, [isDesktopOrLaptop]);

  useEffect(() => {
    if (animationFinished) {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  }, [animationFinished]);

  return (
    <div>
      <img 
        ref={logoRef} 
        src="/assets/images/hashguys-logo.png" 
        alt="Hashguys logo" 
        className="hidden fixed top-0 left-0 bg-transparent z-[9999] absolute relative right-[4px] top-[19px] lg:top-[50px] w-[271px] lg:w-[624px] lg:h-[158px] h-[71px]" 
      /> 
      <div id="loading" className="fixed top-0 left-0 w-screen h-screen bg-gradient-primary flex justify-center z-[9998]"> 
        <img 
          ref={imageRef} 
          src="/assets/images/hashguys-logo.png" 
          alt="Hashguys logo" 
          className="absolute relative lg:right-[25px] top-[3px] lg:top-[6px] w-[271px] h-[71px] lg:w-[624px] lg:h-[158px]" 
        />
      </div>
    </div>
  );
}
